import _ from 'lodash';
import { getConfig } from '../../app/services/config';

const log = (level, ...message) => {
  getConfig().logBiToConsole && console[level](...message);
};

const tryTransformEvent = transformEvent => (action, state) => {
  try {
    return transformEvent(action, state);
  } catch (e) {
    log('error', 'BI: event transformation failed', e, action, state);
  }
};

const tryLogEvent = event => bi => {
  const promise = bi.log(event);
  promise.catch(e => {
    log('error', 'BI: external bi error', e, event);
  });
  return promise;
};

const createBiMiddleware = ({
  bi,
  eventMap,
  extendEvent = event => event,
  shouldInvokeEvent = () => true,
  shouldLogEvent = () => true,
}) => {
  const maybeLog = (action, store) => {
    const transformEvent = eventMap[action.type];

    if (!transformEvent) {
      return _.identity;
    }

    if (!shouldInvokeEvent()) {
      log('error', 'BI: not logged action!', action);
      return _.identity;
    }

    const state = store.getState();
    const biEvent = tryTransformEvent(transformEvent)(action, state); // event => bi event
    if (!biEvent) {
      return _.identity;
    }

    biEvent._ = new Date().getTime();
    // Extend transformEvent with aditional params biToken, visitor_id, member_id
    const extendedEvent = extendEvent(biEvent, state);

    if (!shouldLogEvent(extendedEvent, state)) {
      // not valid because of technical reasons, e.g. missing BI token
      log('error', 'BI: not logged event!', extendedEvent);
      return _.identity;
    }

    return tryLogEvent(extendedEvent);
  };

  return store => next => action => {
    maybeLog(action, store)(bi);

    return next(action);
  };
};

export default createBiMiddleware;



// WEBPACK FOOTER //
// ./app/middleware/bi-middleware.js